import { Col, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useOrderContext } from '../../../../../providers/OrderProvider';
import { filterRewardSummaryForViewer } from '../../../../../constants/orderRewardVisibility';
import formatCurrency from '../../../../../utils/formatCurrency';

const REWARD_ROWS = [
	{ key: 'trueProfit', label: '总利润', className: 'text-primary', format: formatCurrency },
	{ key: 'profitMarginRate', label: '利润率', format: (value) => `${(Math.floor(Number(value || 0) * 10000) / 100).toFixed(2)}%` },
	{ key: 'assistantReward', label: '销售助理', className: 'text-info', format: formatCurrency },
	{ key: 'saleReward', label: '销售员', className: 'text-info', format: formatCurrency },
	{ key: 'salesSupervisorReward', label: '销售主管', className: 'text-info', format: formatCurrency },
	{ key: 'companyProfit', label: '公司最终利润', className: 'text-success', format: formatCurrency },
];

/**
 * 订单奖励汇总展示（订单完成后显示）
 */
const OrderRewardSummary = () => {
	const { order } = useOrderContext();
	const { userInfo } = useSelector((state) => state.auth);
	const reward = filterRewardSummaryForViewer(order?.rewardSummary, userInfo, order);

	if (!order?.uiHints?.canShowOrderRewardSummary) {
		return null;
	}

	if (!reward) {
		return (
			<div className='text-muted fs-10'>
				<span>暂无权限查看奖励金额</span>
			</div>
		);
	}

	const visibleRows = REWARD_ROWS.filter((row) => Object.prototype.hasOwnProperty.call(reward, row.key));

	if (visibleRows.length === 0) {
		return <div className='text-muted fs-10'>暂无权限查看奖励金额</div>;
	}

	return (
		<div className='d-flex flex-column gap-2'>
			<Row className='g-0'>
				{visibleRows.map((row) => (
					<Col key={row.key} xs={row.key === 'trueProfit' || row.key === 'profitMarginRate' ? 6 : 12} className='mb-2'>
						<div className='d-flex align-items-center'>
							<span className='text-muted fs-10'>{row.label}</span>
							<span className={`ms-2 fw-semibold ${row.className || ''}`}>{row.format(reward[row.key])}</span>
						</div>
					</Col>
				))}
			</Row>
		</div>
	);
};

export default OrderRewardSummary;
